var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "14",
        viewBox: "0 0 16 14",
        fill: "none",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_1308_12)" } }, [
        _c("path", {
          attrs: {
            d: "M7.99998 13C12.4187 13 16 10.0906 16 6.5C16 2.90937 12.4187 0 7.99998 0C3.58123 0 -2.43939e-05 2.90937 -2.43939e-05 6.5C-2.43939e-05 7.90938 0.553101 9.2125 1.4906 10.2781C1.43123 11.0437 1.13435 11.725 0.821851 12.2437C0.649976 12.5312 0.474976 12.7625 0.346851 12.9187C0.281226 12.9969 0.231226 13.0563 0.193726 13.0969C0.174976 13.1156 0.162476 13.1313 0.153101 13.1406L0.143726 13.15C-2.43932e-05 13.2937 -0.0406494 13.5063 0.0374756 13.6938C0.115601 13.8813 0.296851 14.0031 0.499976 14.0031C1.39685 14.0031 2.29998 13.725 3.04998 13.4C3.7656 13.0875 4.37498 12.7156 4.74685 12.4438C5.7406 12.8031 6.8406 13.0031 7.99998 13.0031V13ZM3.99998 5.5C4.26519 5.5 4.51955 5.60536 4.70708 5.79289C4.89462 5.98043 4.99998 6.23478 4.99998 6.5C4.99998 6.76522 4.89462 7.01957 4.70708 7.20711C4.51955 7.39464 4.26519 7.5 3.99998 7.5C3.73476 7.5 3.48041 7.39464 3.29287 7.20711C3.10533 7.01957 2.99998 6.76522 2.99998 6.5C2.99998 6.23478 3.10533 5.98043 3.29287 5.79289C3.48041 5.60536 3.73476 5.5 3.99998 5.5ZM7.99998 5.5C8.26519 5.5 8.51955 5.60536 8.70708 5.79289C8.89462 5.98043 8.99998 6.23478 8.99998 6.5C8.99998 6.76522 8.89462 7.01957 8.70708 7.20711C8.51955 7.39464 8.26519 7.5 7.99998 7.5C7.73476 7.5 7.48041 7.39464 7.29287 7.20711C7.10533 7.01957 6.99998 6.76522 6.99998 6.5C6.99998 6.23478 7.10533 5.98043 7.29287 5.79289C7.48041 5.60536 7.73476 5.5 7.99998 5.5ZM11 6.5C11 6.23478 11.1053 5.98043 11.2929 5.79289C11.4804 5.60536 11.7348 5.5 12 5.5C12.2652 5.5 12.5195 5.60536 12.7071 5.79289C12.8946 5.98043 13 6.23478 13 6.5C13 6.76522 12.8946 7.01957 12.7071 7.20711C12.5195 7.39464 12.2652 7.5 12 7.5C11.7348 7.5 11.4804 7.39464 11.2929 7.20711C11.1053 7.01957 11 6.76522 11 6.5Z",
            fill: "black",
          },
        }),
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_1308_12" } }, [
          _c("rect", { attrs: { width: "16", height: "14", fill: "white" } }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }